import { useTranslation } from 'react-i18next';
import {
  TeModal,
  TeContainer,
  TeButton,
  TeText,
  TeIcon,
  TeContainerSlim,
} from '@topcon/tuicl-react';
import { IconName } from '@topcon/tuicl/dist/components/icon/icon.utils';
import { PropsWithChildren } from 'react';

import { DeleteItem } from './ConfirmDeletionModal.types';
import ModalItems from './Modaltems';

interface Props {
  title: string;
  description: string;
  text?: string;
  subText?: string | string[];
  headers?: { text: string; subText: string };
  data?: DeleteItem[];
  primaryButtonText: string;
  primaryButtonVariant?: 'primary' | 'secondary' | 'tertiary';
  secondaryButtonText?: string;
  open: boolean;
  iconName: IconName;
  imageSrc?: string;
  iconColor?: string;
  loading?: boolean;
  onSubmit: () => void;
  onClose: (shouldUpdate: boolean) => void;
}

function ConfirmDeletionModal({
  title,
  description,
  text,
  subText,
  headers,
  data,
  primaryButtonText,
  primaryButtonVariant = 'tertiary',
  secondaryButtonText,
  open,
  iconName,
  imageSrc,
  iconColor,
  loading,
  onSubmit,
  onClose,
  children,
}: PropsWithChildren<Props>) {
  const { t } = useTranslation('common');

  return (
    <TeModal
      variant="dark"
      open={open}
      closeMode="overlay"
      teclose={() => onClose(false)}
      modalTitle={title}
      contentPadding={0}
      closeable
      size="s"
      width="s"
    >
      <TeContainer backgroundColor="background.primary" padding={['m', 's']} column grow>
        <TeContainerSlim gap="xs" alignItems="center">
          <TeContainerSlim>
            <TeIcon name="info" />
          </TeContainerSlim>
          <TeText size={12}>{description}</TeText>
        </TeContainerSlim>

        <ModalItems
          text={text}
          subText={subText}
          headers={headers}
          data={data}
          iconName={iconName}
          iconColor={iconColor}
          imageSrc={imageSrc}
        />
        {children}
      </TeContainer>

      <TeButton
        slot="tertiary"
        text={secondaryButtonText || t('cancel')}
        variant="neutral"
        teclick={() => onClose(false)}
        size="s"
      />
      <TeButton
        slot="primary"
        text={primaryButtonText}
        variant={primaryButtonVariant}
        size="s"
        loading={loading}
        disabled={loading}
        teclick={() => onSubmit()}
      />
    </TeModal>
  );
}

export default ConfirmDeletionModal;
